<template>
    <v-dialog v-model="dialog" max-width="1600" persistent>
        <v-card v-if="dialog">
            <v-card-title class="primary white--text title">
                {{ 'Script'|translate }}
            </v-card-title>
            <v-card-text>
                <v-text-field :label="'Name'|translate" autofocus v-model="activeItem.name"></v-text-field>
                <v-switch color="success"  v-model="activeItem.active" :label="'Active'|translate" ></v-switch>
                <v-layout>
                    <v-flex xs4>
                        <points-draggable disabled clip-mode></points-draggable>
                    </v-flex>
                    <v-flex xs8>


                        <editor v-model="activeItem.config.script" @init="editorInit" lang="python" theme="twilight" width="100%"
                                height="600"></editor>
                        <v-toolbar dense flat class="secondary darken-1">
                            <span v-if="testRunning"> Running </span>
                            <span v-if="!testRunning&&!testRunResult"> Ready </span>
                            <span v-if="!testRunning&&testRunResult&&testRunResult.status==='completed'" class="success--text"> Completed </span>
                            <span v-if="!testRunning&&testRunResult&&testRunResult.status!=='completed'" class="error--text"> Error </span>
                            <v-divider vertical class="grey mr-3 ml-3" small></v-divider>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon
                                        v-on="on"
                                        small
                                        class="mr-3"
                                        @click="runTest()"
                                    >
                                        fa-play
                                    </v-icon>
                                </template>
                                <span>{{'Run test'|translate}}</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-alert v-if="!testRunning&&testRunResult&&testRunResult.status!=='completed'"
                                 :value="true"
                                 type="error"
                                 style="padding: 6px;"
                        >
                            {{testRunResult.status}}
                        </v-alert>
                        <v-alert v-if="!testRunning&&testRunResult&&testRunResult.stderr&&testRunResult&&testRunResult.stderr!==''"
                                 :value="true"
                                 type="error"
                                 outline
                                 style="padding: 6px;"
                        >
                            <pre class="pa-2">{{testRunResult&&testRunResult.stderr}}</pre>
                        </v-alert>
                        <v-alert v-if="!testRunning&&testRunResult&&testRunResult.stdout&&testRunResult&&testRunResult.stdout!==''"
                                 :value="true"
                                 type="info"
                                 outline
                                 style="padding: 6px;"
                        >
                            <label class="pa-2"><strong>Output : </strong></label>
                            <pre class="pa-2">{{testRunResult&&testRunResult.stdout}}</pre>
                        </v-alert>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-btn class="primary ml-2 elevation-4" @click="viewPreviousVersions()" v-if="activeItem.script_id&&activeItem.version">{{ 'Previous Versions'|translate }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn outline class="mr-2" @click="initializeVar(true)">{{ 'Cancel'|translate }}</v-btn>
                <v-btn class="primary mr-2 elevation-4" @click="addRecord(true)" :disabled="!$can('update', 'Script')">
                    {{ 'Save'|translate }}
                </v-btn>

                <v-dialog v-model="oldVersionsDialog" max-width="600" persistent>
                    <v-card v-if="oldVersionsDialog">
                        <v-card-title class="primary white--text title">
                            {{'Previous Versions'|translate}}
                        </v-card-title>
                        <v-card-text>
                            <v-data-table
                                :headers="headers"
                                :items="oldVersions"
                                class="elevation-1"
                                :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                :items-per-page="25"
                            >
                                <template v-slot:items="props">
                                    <td>{{ props.item.version }}</td>
                                    <td>{{ props.item.date ? formatElderDate(props.item.date) : '' }}</td>
                                    <td>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }" >
                                                <v-icon
                                                    small
                                                    v-on="on"
                                                    class="mr-2"
                                                    @click="restoreVersion(props.item)"
                                                >
                                                    fa-download
                                                </v-icon>
                                            </template>
                                            <span>{{'Restore'|translate}}</span>
                                        </v-tooltip>

                                    </td>
                                </template>
                                <template v-slot:no-data>
                                    <v-btn color="primary" @click="initialize">{{'Reset'|translate}}</v-btn>
                                </template>
                            </v-data-table>
                        </v-card-text>

                        <v-card-actions>
                            <v-btn @click="oldVersionsDialog=false">{{'Close'|translate}}</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {putScript, getScriptVersions, testScript} from '../helper'
import editor from 'vue2-ace-editor'
import moment from "moment";
import PointsDraggable from "./multiplots/PointsDraggable";

export default {
    components: {PointsDraggable, editor},
    props: {
        value: {type: Boolean, default: true},
        item: {type: Object, default: null}
    },
    watch: {
        item(item) {
            this.initializeVar()
            if (item) {
                this.activeItem = this.item
            }
        },
        value() {
            if (!this.activeItem.script_id) {
                this.initializeVar()
            }
            if (this.dialog != this.value) {
                this.dialog = this.value
            }
        },
        dialog() {
            this.$emit('input', this.dialog)
        }
    },
    data() {
        return {
            dialog: false,
            testRunning: false,
            testRunResult: null,
            oldVersions:[],
            activeItem: {
                script_id: null,
                name: '',
                config: {
                    script: ""
                },
                active:false,
            },
            headers: [
                { text: this.$options.filters.translate('Version'), value: 'version'},
                { text: this.$options.filters.translate('Date'), value: 'date'},
                { text: this.$options.filters.translate('Actions'), sortable: false },
            ],
            oldVersionsDialog:false,
        }
    },
    methods: {
        async runTest(){
            this.testRunning=true
            this.testRunResult=null
            let tester = await testScript({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                config:this.activeItem.config
            })
            this.testRunResult=tester.result
            this.testRunning=false
        },
        formatElderDate(date){
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        },
        editorInit: function () {
            require('brace/ext/language_tools')
            require('brace/mode/python')
            require('brace/theme/twilight')
        },
        initializeVar(close) {
            this.activeItem = {
                script_id: null,
                name: '',
                config: {
                    script: ""
                },
                active:false,
            }
            this.oldVersions=[]
            this.testRunning=false
            this.testRunResult=null
            if (close) {
                this.dialog = false;
            }
        },
        async addRecord(close) {
            await putScript(
                {
                    'script_id': this.activeItem.script_id,
                    'name': this.activeItem.name,
                    'facility_name':  this.$store.state.pointsListStore.pointsList.facility_name,
                    'config': this.activeItem.config,
                    'active': this.activeItem.active,
                }
            )
            this.$emit('doreload')
            if (close) {
                this.dialog = false;
            }
        },
        async viewPreviousVersions(){
            this.oldVersions=[]
            let df =await getScriptVersions(
                {
                    'script_id': this.activeItem.script_id,
                }
            )
            this.oldVersions=df["result"]
            this.oldVersionsDialog=true
        },
        restoreVersion(item){
            this.activeItem.config=JSON.parse(JSON.stringify(item.config))
            this.oldVersionsDialog=false
        }
    },
    name: 'ScriptDialog'
}
</script>

<style scoped>

</style>
